import React, { useState, useEffect } from "react";

const MyWeeklyReport = () => {
  const [weeklyData, setWeeklyData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [modalLocation, setModalLocation] = useState(null);
  const [taskModalData, setTaskModalData] = useState(null);
  const [taskDetails, setTaskDetails] = useState({
    date: "",
    task: "",
  });
  const getUserRole = () => {
    const roles = localStorage.getItem("roles"); // Assume roles are stored in localStorage
    return roles ? roles.split(",") : []; // Return roles as an array
  };
  const roles = getUserRole();

  useEffect(() => {
    const today = new Date();
    const { startOfWeek, endOfWeek } = getWeekRange(today);
    setStartDate(startOfWeek);
    setEndDate(endOfWeek);
    fetchWeeklyData(startOfWeek, endOfWeek);
  }, [taskModalData]);

  const getWeekRange = (date) => {
    const currentDate = new Date(date);
    const dayOfWeek = currentDate.getDay();
    const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() + diffToMonday);

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    return {
      startOfWeek: formatDate(startOfWeek),
      endOfWeek: formatDate(endOfWeek),
    };
  };

  const saveTask = async () => {
    const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/attendance/my/time-sheets/update-task`;
    const queryParams = new URLSearchParams({
      date: taskDetails.date,
      taskDiscription: taskDetails.task,
    }).toString();

    try {
      const response = await fetch(`${apiUrl}?${queryParams}`, {
        method: "PATCH",
        headers: {
          Accept: "*/*",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Task updated successfully:", result);
        // Optionally, refresh the data to reflect the updated task
        fetchWeeklyData(startDate, endDate);
      } else {
        console.error("Failed to update task:", response.statusText);
      }
    } catch (error) {
      console.error("Error while updating task:", error);
    } finally {
      closeTaskModal();
    }
  };


  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const fetchWeeklyData = async (startOfWeek, endOfWeek) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets/my/date-range?startDate=${startOfWeek}&endDate=${endOfWeek}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      console.log(data);
      
      const groupData = groupDataByDate(data);
      const dataForWeek = groupData.filter(
        (item) => item.date >= startOfWeek && item.date <= endOfWeek
      );
      setWeeklyData(dataForWeek);
    } catch (error) {
      console.error("Error fetching weekly attendance data:", error);
      setWeeklyData([]);
    }
  };

  const handlePrevWeek = () => {
    const prevWeekStart = new Date(startDate);
    prevWeekStart.setDate(prevWeekStart.getDate() - 7);

    const { startOfWeek, endOfWeek } = getWeekRange(prevWeekStart);
    setStartDate(startOfWeek);
    setEndDate(endOfWeek);
    fetchWeeklyData(startOfWeek, endOfWeek);
  };

  const handleNextWeek = () => {
    const nextWeekStart = new Date(startDate);
    nextWeekStart.setDate(nextWeekStart.getDate() + 7);

    const { startOfWeek, endOfWeek } = getWeekRange(nextWeekStart);
    setStartDate(startOfWeek);
    setEndDate(endOfWeek);
    fetchWeeklyData(startOfWeek, endOfWeek);
  };

  const groupDataByDate = (dataArray) => {
    const groupedData = dataArray.reduce((acc, item) => {
      if (!acc[item.date]) {
        acc[item.date] = [];
      }
      acc[item.date].push(item);
      return acc;
    }, {});

    return Object.keys(groupedData).map((date) => ({
      date,
      employees: groupedData[date],
    }));
  };

  const showMapModal = (lat, long) => {
    setModalLocation({ lat, long });
  };

  const closeModal = () => {
    setModalLocation(null);
  };

  const openTaskModal = (employee) => {
    setTaskModalData(employee);
    setTaskDetails({ date: employee.date, task: "" });
  };

  const closeTaskModal = () => {
    setTaskModalData(null);
    setTaskDetails({ date: "", task: "" });
  };

  const handleTaskInputChange = (e) => {
    const { name, value } = e.target;
    setTaskDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  return (
    <>
      <div className="card shadow">
        <div className="card-header d-flex align-items-center justify-content-between bg-primary text-white">
          <h5>
            Weekly Attendance Report ({startDate} to {endDate})
          </h5>
          <div>
            <button
              className="btn btn-light btn-sm me-2"
              onClick={handlePrevWeek}
            >
              Prev Week
            </button>
            <button
              className="btn btn-light btn-sm"
              onClick={handleNextWeek}
              disabled={new Date(startDate).getTime() >= new Date().getTime()}
            >
              Next Week
            </button>
          </div>
        </div>
        <div className="card-body">
          {weeklyData.length > 0 ? (
            weeklyData.map((dayData, index) => (
              <div key={index} className="mb-4">
                <h6>{dayData.date}</h6>
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead className="table-dark">
                      <tr>
                        <th>Employee</th>
                        <th>Login Time</th>
                        <th>Logout Time</th>
                        <th>Login Location</th>
                        <th>Logout Location</th>
                        <th>Task</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dayData.employees.map((employee, idx) => (
                        <tr key={idx}>
                          <td>{employee.employeeName}</td>
                          <td>{employee.loginTime}</td>
                          <td>{employee.logoutTime}</td>
                          <td>
                            {employee.loginLocation ? (
                              <span
                                className="text-primary cursor-pointer"
                                onClick={() =>
                                  showMapModal(
                                    employee.loginLocation.split(", ")[0].replace("Lat: ", ""),
                                    employee.loginLocation.split(", ")[1].replace("Long: ", "")
                                  )
                                }
                              >
                                View Map
                              </span>
                            ) : (
                              "Not Available"
                            )}
                          </td>
                          <td>
                            {employee.logoutLocation ? (
                              <span
                                className="text-primary cursor-pointer"
                                onClick={() =>
                                  showMapModal(
                                    employee.logoutLocation.split(", ")[0].replace("Lat: ", ""),
                                    employee.logoutLocation.split(", ")[1].replace("Long: ", "")
                                  )
                                }
                              >
                                View Map
                              </span>
                            ) : (
                              "Not Available"
                            )}
                          </td>
                          <td>{employee.taskDiscription || "No task. Please add task"}</td>
                          {roles.includes("ROLE_EMP") && !roles.includes("ROLE_ADMIN") ? <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => openTaskModal(employee)}
                            >
                              Add Task
                            </button>
                          </td> : <></>}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          ) : (
            <p>No data available for this week.</p>
          )}
        </div>
      </div>

      {/* Task Modal */}
      {taskModalData && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Task for {taskModalData.employeeName}</h5>
                <button type="button" className="btn-close" onClick={closeTaskModal}></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="taskDate" className="form-label">
                      Date
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="taskDate"
                      name="date"
                      value={taskDetails.date}
                      readOnly
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="taskDescription" className="form-label">
                      Task Description
                    </label>
                    <textarea
                      className="form-control"
                      id="taskDescription"
                      name="task"
                      value={taskDetails.task}
                      onChange={handleTaskInputChange}
                      rows="3"
                    ></textarea>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeTaskModal}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={saveTask}>
                  Save Task
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Map Modal */}
      {modalLocation && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Location Map</h5>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <iframe
                  width="100%"
                  height="400"
                  src={`https://www.google.com/maps?q=${modalLocation.lat},${modalLocation.long}&z=15&output=embed`}
                  frameBorder="0"
                  allowFullScreen
                  title="Google Map"
                ></iframe>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MyWeeklyReport;
